import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-5" }
const _hoisted_2 = { class: "col-span-12 flex flex-col gap-5" }
const _hoisted_3 = { class: "flex items-center justify-between mb-4" }
const _hoisted_4 = { class: "capitalize" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex flex-row justify-end items-center gap-2" }
const _hoisted_7 = { class: "flex items-center justify-between mb-4" }
const _hoisted_8 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.currentObjective.name), 1),
          (_ctx.classroomName)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("labels.generic", { pt: "Turma: ", en: "Classroom: " })) + " " + _toDisplayString(_ctx.classroomName), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Objetivo", en: "Objective" })), 1),
          _createVNode(_component_Dropdown, {
            modelValue: _ctx.currentObjective,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentObjective) = $event)),
            inputId: "dd-city",
            options: _ctx.objectives,
            optionLabel: "name",
            class: "w-[20%] min-w-[250px] md:w-14rem",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToObjective()))
          }, null, 8, ["modelValue", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t("stats.course.sidebar.general")), 1)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "col-span-12 lg:col-span-4"
      }, [
        _createVNode(_component_Card, {
          data: item,
          isEmpty: item.empty
        }, null, 8, ["data", "isEmpty"])
      ]))
    }), 128))
  ]))
}